// 智能内容解析器：识别二维码/条形码内容类型，给出友好展示与操作建议
export function parseContent(text, format) {
    const raw = (text || '').trim();
    const result = {
        raw,
        display: raw,
        format: format || '',
        type: 'text',
        typeLabel: '文本',
        actionLabel: '复制',
        actionIcon: 'description',
        action: { type: 'text', value: raw }
    };

    const fmt = (format || '').toLowerCase();
    const isOneDim = /ean|upc|code|itf|codabar/.test(fmt);

    // === 条形码类型识别 ===
    if (isOneDim || /^\d{6,}$/.test(raw)) {
        // EAN-13 / ISBN
        if (/^ean[-_ ]?13$/i.test(format) || /^\d{13}$/.test(raw)) {
            if (/^97[89]\d{10}$/.test(raw)) {
                result.type = 'isbn';
                result.typeLabel = `图书 ISBN · ${format || 'EAN-13'}`;
                result.display = `ISBN: ${raw}\n点击「查询图书」可在豆瓣查看详情`;
                result.actionLabel = '查询图书';
                result.actionIcon = 'search';
                result.action = { type: 'url', value: `https://search.douban.com/book/subject_search?search_text=${raw}` };
                return result;
            }
            result.type = 'product';
            result.typeLabel = `商品条码 · ${format || 'EAN-13'}`;
            result.display = `条码编号: ${raw}\n点击「查商品」可在京东搜索`;
            result.actionLabel = '查商品';
            result.actionIcon = 'shop-o';
            result.action = { type: 'url', value: `https://search.jd.com/Search?keyword=${raw}` };
            return result;
        }
        if (/^ean[-_ ]?8$/i.test(format) || (isOneDim && /^\d{8}$/.test(raw))) {
            result.type = 'product';
            result.typeLabel = `商品条码 · ${format || 'EAN-8'}`;
            result.display = `条码编号: ${raw}`;
            result.actionLabel = '查商品';
            result.actionIcon = 'shop-o';
            result.action = { type: 'url', value: `https://search.jd.com/Search?keyword=${raw}` };
            return result;
        }
        if (/^upc[-_ ]?a$/i.test(format) || (isOneDim && /^\d{12}$/.test(raw))) {
            result.type = 'product';
            result.typeLabel = `商品条码 · ${format || 'UPC-A'}`;
            result.display = `条码编号: ${raw}`;
            result.actionLabel = '查商品';
            result.actionIcon = 'shop-o';
            result.action = { type: 'url', value: `https://www.amazon.com/s?k=${raw}` };
            return result;
        }
        if (/^upc[-_ ]?e$/i.test(format)) {
            result.type = 'product';
            result.typeLabel = `商品条码 · UPC-E`;
            result.display = `条码编号: ${raw}`;
            result.actionLabel = '查商品';
            result.actionIcon = 'shop-o';
            result.action = { type: 'url', value: `https://www.amazon.com/s?k=${raw}` };
            return result;
        }
        if (/code[ _-]?128/i.test(format) || /code[ _-]?39/i.test(format) || /code[ _-]?93/i.test(format) || /itf|codabar/i.test(format)) {
            result.type = 'barcode';
            result.typeLabel = `条形码 · ${format}`;
            result.display = `内容: ${raw}`;
            result.actionLabel = '复制内容';
            result.actionIcon = 'coupon-o';
            result.action = { type: 'text', value: raw };
            return result;
        }
    }

    // URL
    if (/^https?:\/\//i.test(raw)) {
        result.type = 'url';
        result.typeLabel = '网址链接';
        result.actionLabel = '打开网址';
        result.actionIcon = 'guide-o';
        result.action = { type: 'url', value: raw };
        return result;
    }

    // WIFI
    const wifiMatch = raw.match(/^WIFI:(.+);;?$/i);
    if (wifiMatch) {
        const fields = {};
        wifiMatch[1].split(';').forEach((part) => {
            const idx = part.indexOf(':');
            if (idx > 0) fields[part.slice(0, idx).toUpperCase()] = part.slice(idx + 1);
        });
        result.type = 'wifi';
        result.typeLabel = 'Wi-Fi 网络';
        result.display = `网络: ${fields.S || '-'}\n加密: ${fields.T || '-'}\n密码: ${fields.P || '(无)'}\n隐藏: ${fields.H === 'true' ? '是' : '否'}`;
        result.actionLabel = '复制密码';
        result.actionIcon = 'service-o';
        result.action = { type: 'wifi', value: fields.P || '' };
        return result;
    }

    // 电话
    if (/^tel:/i.test(raw)) {
        const num = raw.replace(/^tel:/i, '');
        result.type = 'tel';
        result.typeLabel = '电话号码';
        result.display = num;
        result.actionLabel = '拨打电话';
        result.actionIcon = 'phone-o';
        result.action = { type: 'tel', value: num };
        return result;
    }

    // 短信
    if (/^sms(to)?:/i.test(raw)) {
        const m = raw.match(/^sms(?:to)?:([^?:]+)(?::(.+))?(?:\?body=(.+))?$/i);
        const num = m ? m[1] : raw;
        result.type = 'sms';
        result.typeLabel = '短信';
        result.display = `发送至: ${num}`;
        result.actionLabel = '发送短信';
        result.actionIcon = 'chat-o';
        result.action = { type: 'sms', value: num };
        return result;
    }

    // 邮件
    if (/^mailto:/i.test(raw)) {
        const addr = raw.replace(/^mailto:/i, '').split('?')[0];
        result.type = 'email';
        result.typeLabel = '电子邮件';
        result.display = addr;
        result.actionLabel = '发送邮件';
        result.actionIcon = 'envelop-o';
        result.action = { type: 'email', value: addr };
        return result;
    }

    // vCard
    if (/^BEGIN:VCARD/i.test(raw)) {
        result.type = 'vcard';
        result.typeLabel = '联系人名片';
        const lines = raw.split(/\r?\n/);
        const name = (lines.find((l) => /^FN:/i.test(l)) || '').replace(/^FN:/i, '');
        const tel = (lines.find((l) => /^TEL/i.test(l)) || '').split(':').pop();
        result.display = [name && `姓名: ${name}`, tel && `电话: ${tel}`, '', '── 原始内容 ──', raw]
            .filter(Boolean)
            .join('\n');
        result.actionLabel = '复制';
        result.actionIcon = 'friends-o';
        return result;
    }

    // Geo
    if (/^geo:/i.test(raw)) {
        const coords = raw.replace(/^geo:/i, '').split('?')[0];
        result.type = 'geo';
        result.typeLabel = '地理位置';
        result.display = `坐标: ${coords}`;
        result.actionLabel = '复制';
        result.actionIcon = 'location-o';
        return result;
    }

    if (format) {
        result.typeLabel = `文本 · ${format}`;
    }
    return result;
}
